export default __webpack_public_path__ + "static/media/BenJaskowiak.fe8e38b5.jpg";